export class StageSaveDto {
  constructor(
    public beginDate: Date,
    public endDate: Date,
    public stageNatureTypeId: number,
    public stageState: string,
    public idBeneficiary: number,
    public label?: string,
    public organization?: string,
    public comment?: string,
    public communityActionId?: number,
    public sessionId?: number,
    public duration?: number,
  ) {}
}
